export function drawDesertBackground(ctx, width, height, time) {
  // Desert sky gradient
  const bgGradient = ctx.createLinearGradient(0, 0, 0, height);
  bgGradient.addColorStop(0, 'hsla(35, 80%, 65%, 0.4)'); // Sandy orange sky
  bgGradient.addColorStop(0.3, 'hsla(30, 85%, 55%, 0.5)'); // Horizon
  bgGradient.addColorStop(0.7, 'hsla(25, 90%, 45%, 0.6)'); // Mid desert
  bgGradient.addColorStop(1, 'hsla(20, 95%, 35%, 0.7)'); // Deep sand
  ctx.fillStyle = bgGradient;
  ctx.fillRect(0, 0, width, height);
}

export function drawSandDunes(ctx, width, height, time) {
  ctx.save();
  
  // Multiple layers of sand dunes
  for (let layer = 0; layer < 4; layer++) {
    const duneHeight = height * (0.15 + layer * 0.08);
    const duneY = height - duneHeight;
    const hue = 30 + layer * 8;
    const alpha = 0.35 - layer * 0.07;
    
    ctx.fillStyle = `hsla(${hue}, 65%, 50%, ${alpha})`;
    ctx.beginPath();
    ctx.moveTo(0, height);
    
    for (let x = 0; x <= width; x += 8) {
      const waveOffset = Math.sin(x * 0.008 + time * 0.25 + layer * 0.5) * 25;
      const secondaryWave = Math.sin(x * 0.02 + time * 0.4 + layer) * 10;
      const y = duneY + waveOffset + secondaryWave;
      ctx.lineTo(x, y);
    }
    
    ctx.lineTo(width, height);
    ctx.closePath();
    ctx.fill();
  }
  
  ctx.restore();
}